import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { LocalStorageService } from '../services/common/local-storage.service';
import { AntiforgerytokenService } from '../services/login/antiforgerytoken.service';
import { IAppState } from '../store/common/interfaces/app-state.interface';
import { selectUserProfileId } from '../store/nowaccount/reducers+selectors/user-profile.selector';
import { destructSubscriptionArray } from '../ui-helpers/functions/destruct-subscription-array';
import { applyUserProfileId } from '../ui-helpers/functions/user-context-url.func';

@Injectable()
export class HeadersInterceptor implements HttpInterceptor, OnDestroy {
  subscriptions: Subscription[] = [];
  properties$: Observable<any>;
  constructor(
    private ls: LocalStorageService,
    private as: AntiforgerytokenService,
    private store: Store<IAppState>,
  ) {}
  // eslint-disable-next-line class-methods-use-this
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const headers: { [key: string]: string } = {};
    const tokenValue = this.as.antiForgeryToken;
    if (tokenValue) {
      headers['__RequestVerificationToken'] = tokenValue;
    }

    let userProfileId: number = -1;
    this.properties$ = this.store.select(selectUserProfileId);
    this.subscriptions.push(
      this.properties$.subscribe((props: { userProfileId: number }) => {
        userProfileId = props.userProfileId;
      }),
    );
    if (userProfileId != -1) {
      headers['UserProfile-Id'] = userProfileId.toString();
    }

    let params = applyUserProfileId(request.params, this.store);

    console.log('HEADER INTERCEPTOR PARAMS');
    console.log(params);

    request = request.clone({
      setHeaders: headers,
      params,
    });

    // console.log('HeadersInterceptor applyUserProfileId');
    // let params = applyUserProfileId(request.params, this.store);

    // request = request.clone({
    //   setHeaders: headers,
    //   params: params,
    // });
    return next.handle(request);
  }

  ngOnDestroy(): void {
    destructSubscriptionArray(this.subscriptions);
  }
}
